import type { AvailableLocaleCodes, AvailableTopLevelLocalesCodes } from './types'

export function getTopLevelLocale(localeCode: AvailableLocaleCodes): AvailableTopLevelLocalesCodes
export function getTopLevelLocale(localeCode: string): string {
  return localeCode.split('-')[0]
}
